import client from '@/api/client.js';
import store from "@/store";
import i18n from '@/plugins/i18n.js'

export default {
    methods: {
        async getUnitListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getUnitListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Unit/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async getUnit(unitId) {
            var meta = { clientApiMethod: 'getUnit', input: { unitId: unitId } }
            var response = await client().get(store.state.apiRouteRoot + "Unit/" + unitId, { meta: meta })
            return response?.data;
        },

        async createUnit(newUnit) {
            var meta = {
                clientApiMethod: 'createUnit',
                input: { newUnit },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.unit.unit") })
            }
            var response = await client().put(store.state.apiRouteRoot + 'Unit', newUnit, { meta: meta })
            return response?.data;
        },

        async changeUnit(updatedUnit) {
            var meta = {
                clientApiMethod: 'changeUnit',
                input: { updatedUnit },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.unit.unit") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Unit', updatedUnit, { meta: meta })
            return response?.data;
        },

        async deleteUnit(unitId) {
            var meta = {
                clientApiMethod: 'deleteUnit',
                input: { unitId: unitId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.unit.unit") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "Unit/" + unitId, { meta: meta })
            return response?.data;
        },


        async addMachinesToUnit(unitId, selectionFilter) {
            var meta = {
                clientApiMethod: 'addMachinesToUnit',
                input: { unitId: unitId, selectionFilter: selectionFilter },
                //successText: i18n.t("servicesystem.responses.updated_object", { okey: i18n.t("servicesystem.common_objects.unit.unit") })
            }
            var response = await client().post(store.state.apiRouteRoot + "Unit/" + unitId + "/add-machines", selectionFilter, { meta: meta })
            return response?.data;
        },

        async removeMachinesFromUnit(unitId, machineIdList) {
            var meta = {
                clientApiMethod: 'removeMachinesFromUnit',
                input: { unitId: unitId, machineIdList: machineIdList },
                //successText: i18n.t("servicesystem.responses.updated_object", { okey: i18n.t("servicesystem.common_objects.unit.unit") })
            }
            var response = await client().post(store.state.apiRouteRoot + "Unit/" + unitId + "/remove-machines", machineIdList, { meta: meta })
            return response?.data;
        }
    }
}